import React from 'react';
import { Map } from 'immutable';
import moment from 'moment';

import ActionsForm from 'src/components/FraudAndCompliance/ActionsForm/ActionsForm.jsx';
import {
    TableWrapper,
    TableHeaderRow,
    TableHeader,
    TableRow,
    TableCell,
    StatusOnlineIndicator,
    CustomerButtonWrapperStatus,
} from './ManualAV.style';
import {
    CustomerId,
    CustomerName,
    ButtonWrapper,
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';
import { PepXmlWrapper } from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';

const ACTIONS = {
    your: [
        { id: 'cancel', name: 'Mark as reviewed' },
        { id: 'unassign', name: 'Unassign' },
    ],
    none: [{ id: 'assign', name: 'Assign to me' }],
    other: [{ id: 'unassign', name: 'Unassign' }],
};

type ActionsType = 'your' | 'none' | 'other';

interface DataListType {
    accountId: number;
    accountName: string;
    assignee: { id: number; type: string; name: string };
    channels: Array<string>;
    createdAt: string;
    details: { firstName: string; surname: string; field: string };
    id: string;
    status: string;
    type: string;
    universeId: string;
}

type DataType = Immutable.Map<unknown, unknown> | Immutable.List<DataListType>;

interface PropsType {
    type: ActionsType;
    status: string;
    className: string;
    onCancelRequest: (matchedAccount: unknown) => void;
    onAssignRequest: (matchedAccount: unknown) => void;
    onUnassignRequest: (matchedAccount: unknown) => void;
    onOpenAccountRequest: (id: number, name: string) => void;
    data: DataType;
    manualAv: {
        isPep: boolean;
    };
}

interface StateType {
    // rows: Array<number>
    xmlAccountId: null | number;
    isOpenModal: boolean;
}

export class ManualAV extends React.Component<PropsType, StateType> {
    public constructor(props: PropsType, context: StateType) {
        super(props, context);

        this.state = {
            xmlAccountId: null,
            isOpenModal: false,
        };
    }
    public static defaultProps = {
        className: '',
    };

    public openAccount(id: number, name: string): void {
        this.props.onOpenAccountRequest(id, name);
    }

    public toggleModal(accountId: number | null, isOpenModal: boolean): void {
        this.setState({
            xmlAccountId: accountId,
            isOpenModal,
        });
    }
    //@ts-expect-error
    public doAction(matchedAccount) {
        //@ts-expect-error
        return (field, action: string): void => {
            const { onCancelRequest, onAssignRequest, onUnassignRequest } = this.props;
            if (action === 'unassign') {
                onUnassignRequest(matchedAccount);
            } else if (action === 'assign') {
                onAssignRequest(matchedAccount);
            } else if (action === 'cancel') {
                onCancelRequest(matchedAccount);
            }
        };
    }

    //@ts-expect-error
    public renderRow(record, type: ActionsType): Array<JSX.Element> {
        const accountId = record.get('accountId');

        const row = (
            <TableRow
                key={record.get('id')}
                section={type}
                data-test={`manual-av-row-${accountId}`}
            >
                <TableCell data-test={`manual-av-date-detected-${accountId}`}>
                    {moment(record.get('createdAt')).format('DD-MM-YYYY HH:mm')}
                </TableCell>

                <TableCell>
                    <CustomerButtonWrapperStatus
                        onClick={(): void =>
                            this.openAccount(record.get('accountId', Map()), record.get('accountName', Map()))
                        }
                        data-test={`manual-av-customer-button-${accountId}`}
                    >
                        <StatusOnlineIndicator>&nbsp;</StatusOnlineIndicator>

                        <CustomerName>{record.get('accountName', Map())}</CustomerName>

                        <CustomerId>{record.get('accountId', Map())}</CustomerId>

                        <span className='tag'></span>
                    </CustomerButtonWrapperStatus>
                </TableCell>

                <TableCell data-test={`manual-av-first-name-${accountId}`}>
                    {record.getIn(['details', 'firstName'])}
                </TableCell>

                <TableCell data-test={`manual-av-surname-${accountId}`}>
                    {record.getIn(['details', 'surname'])}
                </TableCell>

                <TableCell data-test={`manual-av-fields-${accountId}`}>{record.getIn(['details', 'field'])}</TableCell>

                <TableCell data-test={`manual-av-country-${accountId}`}>
                    {record.getIn(['details', 'country'])}
                </TableCell>

                <TableCell>
                    <ActionsForm
                        //eslint-disable-next-line
                        onChange={this.doAction.call(this, record)}
                        actions={ACTIONS[type]}
                        dataTest={`manual-av-actions-select-${accountId}`}
                    />
                </TableCell>
                {this.props.manualAv.isPep ? (
                    <TableCell>
                        <ButtonWrapper
                            version='primary'
                            size='small'
                            width='full'
                            onClick={() => this.toggleModal(record.get('accountId'), true)}
                            dataTest={`manual-av-xml-button-${accountId}`}
                        >
                            XML
                        </ButtonWrapper>
                        {/* {record.get('accountId')} */}
                    </TableCell>
                ) : null}
            </TableRow>
        );
        return [row];
    }

    public render(): JSX.Element {
        const { data, type, manualAv } = this.props;
        const table = (
            <TableWrapper className='call-credit-validation-errors'>
                <thead>
                    <TableHeaderRow>
                        <TableHeader>Date Detected</TableHeader>
                        <TableHeader>Customer</TableHeader>
                        <TableHeader>First Name</TableHeader>
                        <TableHeader>Surname</TableHeader>
                        <TableHeader>Fields</TableHeader>
                        <TableHeader>Country</TableHeader>
                        <TableHeader>Action</TableHeader>
                        {manualAv.isPep ? <TableHeader>Check XML details</TableHeader> : null}
                    </TableHeaderRow>
                </thead>
                <tbody>{data.map((d) => this.renderRow(d, type)).toArray()}</tbody>
            </TableWrapper>
        );

        return (
            <>
                {table}
                {this.state.isOpenModal === true ? (
                    <PepXmlWrapper
                        closeModal={() => this.toggleModal(null, false)}
                        accountId={this.state.xmlAccountId}
                    />
                ) : null}
            </>
        );
    }
}
